import React from "react";

export default function ParticleBackground() {
  return (
    <div className="grid-container">
      <div className="grid-background"></div>
    </div>
  );
}
